import { combineReducers } from 'redux';
import { reducer as dialog } from 'stash/store/slices/dialog.slice';
import signUp from './signUp';
import linkBank from './linkBank';
import setSchedule from './setSchedule';
import refreshTokenPending from './refreshTokenPending';
import ssn from './ssn';
import eSig from './eSig';
import idvStatus from './idvStatus';
import experiments from './experiments';
import onboarding from './onboarding';
import entrySignal from './entrySignal';

export default combineReducers({
	dialog,
	linkBank,
	signUp,
	setSchedule,
	refreshTokenPending,
	ssn,
	eSig,
	idvStatus,
	experiments,
	onboarding,
	entrySignal,
});
